import _ from "lodash";
import {
  addMinutes,
  add,
  intervalToDuration,
  formatDuration as formatDurationFns,
} from "date-fns";
import { zonedTimeToUtc } from "date-fns-tz";

import { localizedTimeService } from "../../i18n/LocalizedTimeService";

export const UNITS = {
  days: "days",
  hours: "hours",
  minutes: "minutes",
};

export function getHoursFromDays(days = 0, hours = 0) {
  return days * 24 + hours;
}

export function getHoursFromMinutes(minutes) {
  return Math.trunc(minutes / 60);
}

export function formatDuration(duration, shortHourMessage, shortMinuteMessage) {
  const { days, hours, minutes } = duration;

  const formatDistanceLocale = {
    xMinutes: `{{count}}${shortMinuteMessage}`,
    xHours: `{{count}}${shortHourMessage}`,
  };
  const shortLocaleFn = {
    formatDistance: (token, count) =>
      formatDistanceLocale[token].replace("{{count}}", count),
  };

  if (days) {
    return (
      getHoursFromDays(days, hours).toString() +
      `${shortHourMessage} ` +
      formatDurationFns(duration, {
        format: [UNITS.minutes],
        locale: shortLocaleFn,
        zero: true,
      })
    );
  } else if (hours) {
    return formatDurationFns(duration, {
      format: [UNITS.hours, UNITS.minutes],
      locale: shortLocaleFn,
      zero: true,
    });
  }

  if (minutes < 2) return `1${shortMinuteMessage}`;
  if (minutes <= 59)
    return formatDurationFns(duration, {
      format: [UNITS.minutes],
      locale: shortLocaleFn,
    });

  return (
    getHoursFromMinutes(minutes).toString() +
    `${shortHourMessage} ` +
    formatDurationFns(duration, {
      format: [UNITS.minutes],
      locale: shortLocaleFn,
    })
  );
}

export function humanizePrecisely(amount, units) {
  if (units === UNITS.minutes) {
    return localizedTimeService.formatDuration({ [units]: _.floor(amount) });
  }

  if (units === UNITS.hours) {
    const hours = _.floor(amount);
    const minutes = _.ceil((amount - hours) * 60);

    return localizedTimeService.formatDuration(
      { hours, minutes },
      { format: [UNITS.hours, UNITS.minutes] }
    );
  }

  return localizedTimeService.formatDuration({ [units]: _.round(amount) });
}

export function calculatePauseTimeEnd(now, pausePeriod) {
  return addMinutes(add(now, pausePeriod), 1);
}

export function getTimeLeft(schedule, now) {
  if (!schedule) {
    return null;
  }

  const end = zonedTimeToUtc(schedule.timeEnd, schedule.timeZone);

  return intervalToDuration({ start: now, end });
}
